import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { initiateCall, selectCallStatus } from '../../redux/slices/callSlice';
import './CallButton.css';

const CallButton = ({ onClick }) => {
  const dispatch = useDispatch();
  const status = useSelector(selectCallStatus);
  const isRinging = status === 'calling' || status === 'connected';

  const handleClick = () => {
    dispatch(initiateCall());
    if (onClick) onClick();
  };

  if (isRinging) return null;

  return (
    <div className="call-button-container animate-float">
      <div className="call-button-pulse"></div>
      <div className="call-button-pulse delay-1"></div>
      <div className="call-button-pulse delay-2"></div>
      <button
        className="call-button"
        onClick={handleClick}
        aria-label="Talk to AI"
      >
        <i className="bi bi-telephone-fill"></i>
      </button>
      <span className="call-button-label">Talk to AI</span>
    </div>
  );
};

export default CallButton;
